module.exports = "//static.hsappstatic.net/pricing-pages-lib/static-1.27462/images/hubspot-credits/hero.png"